import { PageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Ui/PageManager";
import pageManagerConfigurationBase from "./PageManagerConfigurationBase.Generated";

const
    configuration: PageManagerConfiguration = {
        detailsPageMap: {
            ...pageManagerConfigurationBase.detailsPageMap,
        },
        indexPageMap: {
            ...pageManagerConfigurationBase.indexPageMap,
            "JobSchedule": async () => (await import("./Pages/Entities/JobSchedules/JobScheduleIndexPage")).JobScheduleIndexPage,
        },
        routes: {
            ...pageManagerConfigurationBase.routes,
            "/modules/jobs/": async () => (await import("./Pages/JobDashboardPage")).JobDashboardPage,
        }
    };

export default configuration;